import { render, staticRenderFns } from "./ClientRenew.vue?vue&type=template&id=498b9d98&scoped=true"
import script from "./ClientRenew.vue?vue&type=script&lang=js"
export * from "./ClientRenew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498b9d98",
  null
  
)

export default component.exports